module.exports = __webpack_public_path__ + "media/images/cliparts/Work office 10-6459d5cc6d08a94e1ba54d39d5083b84.svg";